// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationFeaturesText-cls1_S76","cls2":"TranslationFeaturesText-cls2_8eP TranslationFeaturesText-cls1_S76"};